import './PathErrorPage.css';
import pathPageErrorImage from '../static/path_page_error_image.png';
import { useLanguage } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

const PathErrorPage = () => {
  const { language } = useLanguage();
  const translation = getTranslation(language);

  return (
    <div className='path-error-page'>
      <img src={pathPageErrorImage} alt='Error illustration' className='path-error-image' />
      <h2 className='path-error-title'>{translation.path_error_title}</h2>
      <p className='path-error-message' style={{ whiteSpace: 'pre-line' }}>
        {translation.path_error_message}
      </p>
    </div>
  );
};

export default PathErrorPage;
